module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/coffee-kitchen-large-166badc7a6dcd7327a081b49b6e696d9.svg";